import React, { useCallback, useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import { updateFulfillmentStatuses } from '../fulfillments.api';
import { FulfillmentContext } from '../context';
import { FULFILLMENTS_UPDATED } from '../../../services/pusher-service/pusher-contract-messages';
import { usePusherEvent } from '../../../hooks/use-pusher-event';

const messages = defineMessages({
  errorUpdating: {
    description: 'update fulfillment status request error',
    defaultMessage: 'Error updating fulfillment {amountSelected, plural, one {status} other {statuses}}. Please try again.',
    id: 'T/WC+z',
  },
  buttonText: {
    description: 'Fulfillments Grid Update Status Button text',
    defaultMessage: 'Update Status',
    id: 'wglfpv',
  },
});

let updateStatusCount = 0;

export const UpdateStatusButton = () => {
  const { selectedFulfillmentIds, setFulfillmentIdsUpdating, refreshGridData } = useContext(FulfillmentContext);
  const amountSelected = selectedFulfillmentIds.length;
  const disabled = amountSelected === 0;

  const onClick = useCallback(() => {
    updateFulfillmentStatuses(selectedFulfillmentIds)
      .then(() => {
        setFulfillmentIdsUpdating(selectedFulfillmentIds);
      })
      .catch(() => {
        NotificationService.showNotification({
          title: '',
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.errorUpdating} value={{ amountSelected }} />,
          duration: 3000,
        });
      });
  }, [amountSelected, selectedFulfillmentIds, setFulfillmentIdsUpdating]);

  const onPusherMessage = useCallback(() => {
    if (updateStatusCount === amountSelected) {
      refreshGridData();
      setFulfillmentIdsUpdating([]);
      updateStatusCount = 0;
      return;
    }

    updateStatusCount++;
  }, [refreshGridData, amountSelected, setFulfillmentIdsUpdating]);

  usePusherEvent(FULFILLMENTS_UPDATED, onPusherMessage);

  return <ReuseableGridButton actionHandler={onClick} disable={disabled} messageDescriptor={messages.buttonText} theme='tertiary' />;
};
